import { restClient } from '../config/restClient'

const endpoint = hiringTeamId => `/api/company/v2/hiring_teams/${hiringTeamId}/session_metadata`

export const getHiringTeamSessionMetadata = async hiringTeamId => {
  const response = await restClient(endpoint(hiringTeamId), {
    method: 'GET',
  })
  return response.data
}
